import script from "./ConfirmationRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationRegister.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationRegister.vue?vue&type=style&index=0&id=558a833a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558a833a"]])

export default __exports__